export const getParameterByName = (name: string, url: string = window.location.href): string => {
  name = name.replace(/[[]/, '\\[').replace(/[\]]/, '\\]');
  const regex = new RegExp('[\\?&]' + name + '=([^&#]*)'),
    results = regex.exec(url);

  return results === null ? '' : decodeURIComponent(results[1].replace(/\+/g, ' '));
};
